var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"syj_awardprize syj_bg"},[_vm._m(0),_c('div',{staticClass:"chartBox syj_page-width"},[_c('div',{ref:"another",style:({ width: '1200px', height: '100%' })})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('title',{staticClass:"commom-title"},[_c('span',[_vm._v("获奖统计")])])
}]

export { render, staticRenderFns }